const { a2hsState } = window;
export const a2hs = {
  addHandler(fn) {
    a2hsState.canInstall ? fn(a2hsState.deferredEvent) : a2hsState.callbacks.push(fn);
  },
  removeHandler(fn) {
    const i = a2hsState.callbacks.indexOf(fn);
    if (i < 0) {
      return;
    }
    a2hsState.callbacks.splice(i, 1);
  },
  async prompt() {
    if (!a2hsState.deferredEvent) {
      return;
    }
    a2hsState.deferredEvent.prompt();
    const choice = await a2hsState.deferredEvent.userChoice;
    a2hsState.deferredEvent = null;
    a2hsState.canInstall = false;
    return choice.outcome;
  },
};
